import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { fetchUserAlertSuccessAction } from '@app/store/actions/global.actions';
import { AlertResponse } from '@shared/widgets/entities/alerts';
import { deleteAlertAction } from '@shared/widgets/store/actions/alerts.action';
import { withFlexDates } from '@shared/widgets/mappers/alert-payload.mapper';

export interface AlertCollectionState extends EntityState<AlertResponse> {}

function getId(alert: AlertResponse): number {
  return alert.id;
}

export const alertsAdapter: EntityAdapter<AlertResponse> = createEntityAdapter<AlertResponse>({
  selectId: getId
});

export const initialState: AlertCollectionState = alertsAdapter.getInitialState({});

export const reducer = createReducer(
  initialState,
  on(fetchUserAlertSuccessAction, (state, { alerts }) => {
    return alertsAdapter.setAll(mapAlerts(alerts), state);
  }),
  on(deleteAlertAction, (state, { alert }) => {
    return alertsAdapter.removeOne(alert.id, state);
  })
);


export function alertsReducer(state: AlertCollectionState, action: Action): AlertCollectionState {
  return reducer(state, action);
}

function mapAlerts(alerts: AlertResponse[]): AlertResponse[] {
  return alerts.map(alert => ({
    ...alert,
    flex_dates: withFlexDates(alert)
  }));
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = alertsAdapter.getSelectors();

export const exportedForTesting = {
  getId,
};
